import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import EditAddEmail from "../pages/emailTemplate/Edit";
import EmailTemplateLits from "../pages/emailTemplate/List";
import ViewEmailTemplate from "../pages/emailTemplate/View";
import GlobalSetting from "../pages/Global Setting";
import ViewContestmanager from "../pages/contestmanager/View";
import AddEditContestManager from "../pages/contestmanager/AddEdit";
import ListContestManager from "../pages/contestmanager/List";
import TournamentTeamsList from "../pages/tournaments/List";
import UpdateTeam from "../pages/tournaments/UpdateTeam";


//CMS............................................................ ............................
const CmsPage = lazy(() => import("../pages/content/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/content/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/content/cms/AddEditCms"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));
const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

// Notification
const NotificationList = lazy(() =>
  import("../pages/Notificationmanagement/ListNotification")
);
const NotificationSent = lazy(() =>
  import("../pages/Notificationmanagement/SentNotification")
);

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));

// subadmin
const SubAdminList = lazy(() => import("../pages/subadmin/List"));
const SubAdminView = lazy(() => import("../pages/subadmin/View"));
const SubAdminAddEdit = lazy(() => import("../pages/subadmin/AddEdit"));

// user
const UserList = lazy(() => import("../pages/users/List"));
const UserView = lazy(() => import("../pages/users/View"));
const UserAddEdit = lazy(() => import("../pages/users/AddEdit"));

// blocked ips
const BlockedIpsList = lazy(() => import("../pages/blockedIp/ListBlockedIps"));
const BlockedIpsView = lazy(() => import("../pages/blockedIp/ViewBlockedIps"));
const BlockedIpsAddEdit = lazy(() =>
  import("../pages/blockedIp/AddEditBlockedIps")
);

// Banner Management
const BannerList = lazy(() => import("../pages/banner/List"));
const AddEditBanner = lazy(() => import("../pages/banner/AddEdit"));
const ViewBanner = lazy(() => import("../pages/banner/View"));

// tournament teams
const ALlTournamentlist = lazy(() => import("../pages/tournaments/AllList"));
const TournamentView = lazy(() => import("../pages/tournaments/View"));
const TournamentTeams = lazy(() => import("../pages/tournaments/List"));

// faq
const ListAllFaq = lazy(() => import("../pages/faq/ListAllFaq"));
const AddFaq = lazy(() => import("../pages/faq/AddFaq"));
const EditFaq = lazy(() => import("../pages/faq/EditFaq"));
const ViewFaq = lazy(() => import("../pages/faq/ViewFaq"));

//NotificationTemplates
const NotificationTemplatesList = lazy(() =>
  import("../pages/notificationTemplate/List.jsx")
);
const NotificationTemplatesAddedit = lazy(() =>
  import("../pages/notificationTemplate/AddEdit.jsx")
);
const NotificationTemplatesView = lazy(() =>
  import("../pages/notificationTemplate/View.jsx")
);
///support 
const SupportList = lazy(()=>import("../pages/support/List.jsx"))
const SupportView =  lazy(()=>import("../pages/support/View.jsx"))

/// language
const LanguageList = lazy(()=>import("../pages/language/List.jsx"))
const LanguageView = lazy(()=>import("../pages/language/View.jsx"))
const LanguageAdd = lazy(()=>import("../pages/language/Add.jsx"))

/// howtoplay
const HowtoplayList = lazy(()=>import("../pages/howtoplay/List.jsx"))
const HowtoplayView = lazy(()=>import("../pages/howtoplay/View.jsx"))
const HowtoplayAdd = lazy(()=>import("../pages/howtoplay/Add.jsx"))

/// fantasypoints
const AddEditFantasyPoints = lazy(()=>import("../pages/fantasypoints/AddEdit.jsx"))
const FantasypointsList = lazy(()=>import("../pages/fantasypoints/List.jsx"))
/// teams manager
const TeamsManagerList = lazy(() => import("../pages/teamsmanager/List.jsx"));
const TeamsManagerView = lazy(() => import("../pages/teamsmanager/View.jsx"));



const LoadingFallback = <div>Loading...</div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = () => {
  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "language",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <LanguageList />),
            },
            
            {
              path: "view/:id",
              element: makeLazyComponent(() => <LanguageView />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <LanguageAdd />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <LanguageAdd />),
            },
          ],
        },
        {
          path: "howtoplay",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <HowtoplayList />),
            },
            
            {
              path: "view/:id",
              element: makeLazyComponent(() => <HowtoplayView />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <HowtoplayAdd />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <HowtoplayAdd />),
            },
          ],
        },

        {
          path: "resetpassword",
          element: makeLazyComponent(() => <ChangePassword />),
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
          EmailTemplateLits,
        },
        {
          path: "global-settings",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        {
          path: "cms",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CmsPage />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCms />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCms />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCms />),
            },
          ],
        },
        {
          path: "blocked-ips",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <BlockedIpsList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <BlockedIpsAddEdit />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <BlockedIpsAddEdit />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <BlockedIpsView />),
            },
          ],
        },
        {
          path: "users",
          children: [
            { index: true, element: makeLazyComponent(() => <UserList />) },
            { path: "add", element: makeLazyComponent(() => <UserAddEdit />) },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <UserAddEdit />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <UserView />),
            },
          ],
        },
        {
          path: "sub-admin",
          children: [
            { index: true, element: makeLazyComponent(() => <SubAdminList />) },
            {
              path: "add",
              element: makeLazyComponent(() => <SubAdminAddEdit />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <SubAdminAddEdit />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <SubAdminView />),
            },
          ],
        },
        {
          path: "notification_manager",
          children: [
            {  path: "sent", element: makeLazyComponent(() => <NotificationSent />) },
            {
              path: "received",
              element: makeLazyComponent(() => <NotificationList />),
            },
            
          ],
        },
        {
          path: "email-template",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <EmailTemplateLits />),
            },
            { path: "add", element: makeLazyComponent(() => <EditAddEmail />) },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditAddEmail />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewEmailTemplate />),
            },
          ],
        },
        {
          path: "banners",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <BannerList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditBanner />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditBanner />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewBanner />),
            },
          ],
        },

        {
          path: "contest",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ListContestManager />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditContestManager />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditContestManager />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewContestmanager />),
            },
          ],
        },
         {
          path: "fantasypoints",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <FantasypointsList />), 
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditFantasyPoints />), 
            },
            
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditFantasyPoints />),
            },
          ],
        },
        {
          path: "teamsmanager",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <TeamsManagerList />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <TeamsManagerView />), // get one team by id
            },
          ],
        },
        {
          path: "tournaments",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ALlTournamentlist />), // all tournamnt list
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <TournamentView />), // get one team by id
            },
            {
              path: "viewteam/:id",
              element: makeLazyComponent(() => <TournamentTeamsList />), // all teams of a trouname id
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <UpdateTeam />), // Update Tournament team
            },
          ],
        },
        {
          path: "faqs",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ListAllFaq />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewFaq />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddFaq />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditFaq />),
            },
          ],
        },

        {
          path: "notificationTemplates",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <NotificationTemplatesList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => (
                <NotificationTemplatesAddedit />
              )),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => (
                <NotificationTemplatesAddedit />
              )),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <NotificationTemplatesView />),
            },
          ],
        },

        {
          path:"support",
          children:[
            {
              index:true,
               element:makeLazyComponent(()=><SupportList/>)
            },
            {
              path:"view/:id",
              element:makeLazyComponent(()=><SupportView/>)
            }
          ]
        }
      ],
    },
    { path: "*", element: <Navigate to="/dashboard" /> },
  ];

  return useRoutes(routes);
};

export default MainRouting;
